import Vue from 'vue'
import * as gtm from '~/utils/gtm-events'
import breadcrumbs from '~/breadcrumbs.json'

// Blog detail routes need blog-style content_groups, so the plugin defers
// page_description on those — the blog detail page fires it from mounted().
function isBlogDetail(route) {
  const path = route && route.path
  if (!path || !path.startsWith('/blog/')) return false
  if (
    path === '/blog/' ||
    path === '/blog' ||
    path.startsWith('/blog/search') ||
    path.startsWith('/blog/page/') ||
    path.startsWith('/blog/kategori/')
  ) {
    return false
  }
  return true
}

export default ({ app }, inject) => {
  if (process.server) return

  // Build the slug → page_type map from the committed breadcrumbs snapshot
  // so clicks fired from global components (Header/Footer/Nav) report a
  // sensible page_type on every page, not just SEO-doc-named slugs.
  gtm.setSlugPageTypeMap(gtm.buildSlugPageTypeMap(breadcrumbs))

  inject('gtm', gtm)

  let previousUrl = ''

  const firePageEvents = (route, isInitial) => {
    if (!route) return

    if (!isBlogDetail(route)) {
      gtm.pushPageDescriptionEvent(route.fullPath || route.path || '/')
    }

    Vue.nextTick(() => {
      const referrer = isInitial ? document.referrer || '' : previousUrl
      gtm.pushVirtualPageViewEvent(
        document.title,
        window.location.href,
        referrer
      )
      previousUrl = window.location.href
    })
  }

  app.router.afterEach((to) => firePageEvents(to, false))

  // Initial hydration: wait for head/meta to apply before firing.
  if (app.router.app && app.router.app.$nextTick) {
    app.router.app.$nextTick(() => firePageEvents(app.router.currentRoute, true))
  } else {
    Vue.nextTick(() => firePageEvents(app.router.currentRoute, true))
  }
}
